<template>
  <v-container fluid pa-0>
    <v-layout row wrap>
      
      <v-flex d-flex xs12 md8 lg8 :class="$vuetify.breakpoint.mdAndUp ? 'map' : 'map-sm'">
      	<Mapbox name="map">
      		<MapboxMarkers :locations="locations"></MapboxMarkers>
      	</Mapbox>
      </v-flex>

      <v-flex xs12 md4 lg4 grid-list-xs :class="$vuetify.breakpoint.smAndDown ? 'rydes-sm' : 'rydes'">
        <v-card>
         <RydesList :origin="origin" :destination="destination"></RydesList>
        </v-card>
      </v-flex>

      <v-flex xs12>
        <v-btn color="primary" @click.native="share">Share</v-btn>
      </v-flex>

    </v-layout>
  </v-container>
</template>

<script>
  import axios from 'axios'
  import { eventBus } from '../main'
  // import Directions from '@/components/Directions'
  import Mapbox from '../components/Mapbox'
  import MapboxMarkers from '../components/MapboxMarkers'
  import RydesList from '../components/RydesList'


  export default {
    name: 'rydes',
    data() {
      return {
        rydes: [], 
        loading: true, 
        resize: false, 
        birdBikes: [], 
        
      }
    }, 
    components:{
      Mapbox, 
      MapboxMarkers, 
      RydesList
      // Directions
    },
    mounted: function() {
      
      if(this.$route.params.origin && this.$route.params.dest){
        this.getZoomRydeInformation(this.$route.params.origin, this.$route.params.dest, (response)=> {
          response.data.forEach((item) => {
            this.rydes.push(item)
          })
        });

        // this.getBirdData();
      }
    },
    methods: {
      getZoomRydeInformation(origin, destination, callback){
        var splitOrigin = origin.split(',')
        var splitDestination = destination.split(',')

        axios.get('https://zoomryde.com/getrides.php?action=getpricesestimates', {
          params: {
            currentLat: splitOrigin[0], 
            currentLong: splitOrigin[1],
            finalLat: splitDestination[0],
            finalLong: splitDestination[1],
          }
        })
        .then((response) => {
          this.loading = false;
          callback(response);
        })
        .catch((err) => {
          console.log(err);
        })
      }, 
      share(){
        if(navigator.share){
          navigator.share({title:'Current Page', url: window.location.href})
          .then(() => {
            eventBus.$emit('snackAlert', {color: 'success', text: 'You shared a link, congrats!'})
          });
        }
      },
      getLink(ryde, origin = this.$route.params.origin, destination = this.$route.params.dest){
        if(this.$route.params.origin && this.$route.params.dest){
          var splitOrigin = origin.split(',')
          var splitDestination = destination.split(',')

          if(ryde.displayName.indexOf('Taxi') != -1){
            return 'tel://'+ryde.phoneNumber;
          } else if (ryde.displayName.indexOf('Lyft') != -1){
            return 'https://lyft.com/ride?id='+ryde.rideID+'&pickup[latitude]='+splitOrigin[0]+'&pickup[longitude]='+splitOrigin[1]+'&partner=vDHSSfHzKlze&destination[latitude]='+splitDestination[0]+'&destination[longitude]='+splitDestination[1]+''
          } else if (ryde.displayName.indexOf('Uber') != -1){
            return 'https://m.uber.com/ul/?client_id=Dezdtol77lCZ8Tg8MeHTslkALS_BN3yB&action=setPickup&pickup[latitude]='+splitOrigin[0]+'&pickup[longitude]='+splitOrigin[1]+'&pickup[nickname]=Me&pickup[formatted_address]='+splitOrigin[2]+'&dropoff[latitude]='+splitDestination[0]+'&dropoff[longitude]='+splitDestination[1]+'&dropoff[nickname]=Destination&dropoff[formatted_address]='+splitDestination[2]+'&product_id='+ryde.rideID+'&link_text=View%20team%20roster&partner_deeplink=partner%3A%2F%2Fteam%2F9383';
          }
        }
      },
      getBirdData(){
        let birdData = { 
          data: {
            latitude: this.$route.params.origin, 
            longitude: this.$route.params.dest
          }
        }

        axios.post('http://localhost:5000/zoomryde/us-central1/getBirdLocations', 
        birdData,
        {
          headers: {
            'Content-Type': 'application/json'
          }
        }) 
        .then((response) => {
          // Get the result object, and unpacks the value of bird into the variable birds
          const { birds } = response.data.result
          var birdBikeData = []

          birds.forEach( (bird) => {
            birdBikeData.push({
              title: bird.code,
              latlng: {
                lat: bird.location.latitude,
                lng: bird.location.longitude
              }
            })
          })

          this.birdBikes = birdBikeData.slice(0, 15);

        })
        .catch((err) => {
          console.log(err);
        })
        .finally(() => {
          console.log('We are completed!')
        })
      },
    }, 
    computed: {
      origin: function() {
        const splitOrigin = this.$route.params.origin.split(',')
        // console.log(splitOrigin);
        return {
          geometry: {
            location: {
              lat: Number.parseFloat(splitOrigin[0]),
              lng: Number.parseFloat(splitOrigin[1])
            }
          },
          address: splitOrigin.slice(2).join(',')
        }          
      },
      destination: function(){
        const splitDestination = this.$route.params.dest.split(',');
        // console.log(splitDestination);
        return {
          geometry: {
            location: {
              lat: Number.parseFloat(splitDestination[0]),
              lng: Number.parseFloat(splitDestination[1])
            }
          }, 
          address: splitDestination.slice(2).join(',')
        }
      }, 
      locations: function(){
        const o = this.$route.params.origin.split(',')
        const d = this.$route.params.dest.split(',')

        return [
          {
              title: "Origin",
              latlng: {
                lat: Number.parseFloat(o[0]),
                lng: Number.parseFloat(o[1])
              }
          }, 
          {
            title: "Destination",
            latlng:{
              lat: Number.parseFloat(d[0]),
              lng: Number.parseFloat(d[1])
            }
          }
        ]
      },
    }
  }
</script>
<style>
  .text-center{
    text-align: center;
  }

  .map{
    height: calc(100vh - 110px);
  }

  .map-sm{
  	height: 350px;
  }

  .rydes{
    height: calc(100vh - 100px);
    overflow: auto;
  }

  .rydes-sm{
    height: 50vh;
    overflow: auto;
  }
</style>